// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from 'app/components/CRUD/AddEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
} from 'app/configuration/configuration-api';

/**
 * Assignment form, not a free-text form: the junction table holds nothing but
 * the two foreign keys, so both fields are dropdowns.
 *
 * Duplicate issuer↔organisation pairs are refused by the API with a translated
 * 409 ("This issuer is already assigned to that organisation"), which AddEntity
 * surfaces in a toast. The check has to live server-side — the list this form
 * sits behind is paginated, so the client cannot see every existing pair.
 */
const AddFareMediaIssuerOrganization: React.FC = () => {
  const dropdowns = [
    {
      name: 'fare_media_issuer_id',
      labelKey: 'FareMediaIssuer',
      required: true,
      defaultValue: '',
      apiUrl: CONFIG_PATHS.fareMediaIssuersLookup,
      apiMethod: 'GET',
      dataPath: 'data.data',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'en_issuer_name',
        labelKeyAr: 'ar_issuer_name',
      },
    },
    {
      name: 'organisation_id',
      labelKey: 'Organisation',
      required: true,
      defaultValue: '',
      // Already scoped: returns every organisation for a super admin, and only
      // the caller's own otherwise — matching what the API will accept.
      apiUrl: CONFIG_PATHS.organisations,
      apiMethod: 'GET',
      dataPath: 'data.data',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'en_name',
        labelKeyAr: 'ar_name',
      },
    },
  ];

  const buildSubmitPayload = formValues => ({
    fare_media_issuer_id: formValues.fare_media_issuer_id,
    organisation_id: formValues.organisation_id,
  });

  return (
    <AddEntity
      pageTitle="AddNewFareMediaIssuerOrganization"
      backUrl={CONFIG_ROUTES.fareMediaIssuerOrganisations}
      submitApiUrl={CONFIG_PATHS.fareMediaIssuerOrganisations}
      inputs={[]}
      dropdowns={dropdowns}
      buildSubmitPayload={buildSubmitPayload}
      successMessage="FareMediaIssuerOrganizationCreatedSuccessfully"
      addButtonLabel="Add"
      subsystemName="FareMediaIssuersOrganisations"
      permissionSystem="masterConfig"
    />
  );
};

export default AddFareMediaIssuerOrganization;
